import { render, staticRenderFns } from "./rolemenus.vue?vue&type=template&id=3e5d4581&"
import script from "./rolemenus.vue?vue&type=script&lang=js&"
export * from "./rolemenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports